export const SEARCH_TEXT_CHANGE = 'SEARCH_TEXT_CHANGE';
export const GET_HEADER_SEARCH_RESULTS = 'GET_HEADER_SEARCH_RESULTS';
export const GET_HEADER_SEARCH_RESULTS_SUCCESS = 'GET_HEADER_SEARCH_RESULTS_SUCCESS';
export const GET_HEADER_SEARCH_RESULTS_FAILURE = 'GET_HEADER_SEARCH_RESULTS_FAILURE';

export const SET_IS_MISSING_SOMETHING_MODAL_VISIBLE = 'SET_IS_MISSING_SOMETHING_MODAL_VISIBLE';
export const RESET_SEARCH_RESULT = 'RESET_SEARCH_RESULT';
